/**
 * External dependencies
 */
import React from "react";
import { Box, Text } from "@towersystems/towersystems-design-system";

/**
 * Internal dependencies
 */
import Button from "components/button";
import Icon from "components/icon";

/**
 * Style dependencies
 */
import "./sidebar.scss";

const SidebarOverlay = ({ children, goBack }) => {
  return (
    <Box className="report-builder__sidebar-overlay" background="card">
      <Box
        padding="medium"
        className="report-builder__sidebar-overlay-back-container"
      >
        <Button text onClick={goBack}>
          <Box display="flex" alignItems="center">
            <Icon size="10" marginRight={5} name="BsChevronLeft" />
            <Text size="small">Back</Text>
          </Box>
        </Button>
      </Box>
      <Box>{children}</Box>
    </Box>
  );
};

export default SidebarOverlay;
